<template>
  <div class="note l-inner">
    <ul class="m-list note__wrap">
      <li class="m-list__item note__item" v-if="lowerDir">
        ※上記の仕様は2020年5月現在のものです。予告なしに変更することがあります。
      </li>
      <li class="m-list__item note__item" v-if="lowerDir">
        ※装備は改良のため予告なく変更することがあります。写真は一部欧州仕様となります。導入車両と仕様が異なる場合があります。
      </li>
      <li class="m-list__item note__item" v-if="lowerDir">
        ※掲載写真の色は実際とは異なる場合があります。
      </li>
      <li class="m-list__item note__item">
        ※詳しくは販売店にお問い合わせください。
      </li>
      <li class="m-list__item note__item">
        ※本サイトはInternet
        Explorer、Chrome、FireFox、Safariの最新版でご覧になることを推奨いたします。
      </li>
      <li class="m-list__item note__item">
        ※推奨環境下でもお客様のブラウザ設定、またこれ以外のブラウザからご覧の場合は本サイトをご利用できない場合や表示が乱れる場合などがあります。
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "note-section",
  data: function () {
    return {
      lowerDir: "",
    };
  },
  watch: {
    $route: function () {
      this.lowerDir = this.$route.name == "Index";
    },
  },
  methods: {
    lowerCheck: function () {
      var result = this.$route.name == "Index";
      this.lowerDir = result;
    },
  },
  mounted: function () {
    this.lowerCheck();
  },
};
</script>
<style lang="scss">
.l-inner {
  margin-left: auto;
  margin-right: auto;
}
.m-list {
  &__item {
    padding-left: 1em;
    text-indent: -1em;
  }
}
.note {
  margin-top: 45px;
  margin-bottom: 50px;
  max-width: 1160px;
  width: 100%;
  font-size: 12px;
  line-height: 2.083333333333333;
}
</style>
